import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin: 25px 0 20px;\n  margin: ', ';\n'], ['\n  margin: 25px 0 20px;\n  margin: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: ', ';\n'], ['\n  display: flex;\n  flex-direction: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  list-style: none;\n  margin: ', ';\n'], ['\n  list-style: none;\n  margin: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 15px;\n  line-height: 1.6;\n  margin-bottom: 12px;\n  padding-left: 25px;\n  position: relative;\n  font-weight: ', ';\n  svg {\n    position: absolute;\n    left: 0px;\n    width: 17px;\n    height: 18px;\n  }\n\n  a {\n    color: ', ';\n    text-decoration: underline;\n  }\n'], ['\n  color: ', ';\n  font-size: 15px;\n  line-height: 1.6;\n  margin-bottom: 12px;\n  padding-left: 25px;\n  position: relative;\n  font-weight: ', ';\n  svg {\n    position: absolute;\n    left: 0px;\n    width: 17px;\n    height: 18px;\n  }\n\n  a {\n    color: ', ';\n    text-decoration: underline;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 15px;\n  line-height: 1.6;\n  margin: ', ';\n'], ['\n  color: ', ';\n  font-size: 15px;\n  line-height: 1.6;\n  margin: ', ';\n']);

import styled from 'styled-components';

export var ProductDetailsWrapper = styled.div(_templateObject, function (_ref) {
  var bundle = _ref.bundle;
  return bundle ? '0 0 20px' : '25px 0 35px';
});

export var StyledContentWrapper = styled.div(_templateObject2, function (_ref2) {
  var bundle = _ref2.bundle;
  return bundle ? 'column-reverse' : 'column';
});

export var StyledUl = styled.ul(_templateObject3, function (_ref3) {
  var bundle = _ref3.bundle;
  return bundle ? '0' : '0 0 35px';
});

export var StyledLi = styled.li(_templateObject4, function (props) {
  return props.theme.dormifyBoulder;
}, function (_ref4) {
  var shippingSurcharge = _ref4.shippingSurcharge;
  return shippingSurcharge ? 'bold' : 'normal';
}, function (props) {
  return props.theme.dormifyBoulder;
});

export var StyledDescriptionDiv = styled.div(_templateObject5, function (props) {
  return props.theme.dormifyBoulder;
}, function (_ref5) {
  var bundle = _ref5.bundle;
  return bundle ? '0 0 35px' : '0';
});